import { csx } from '@vtex/admin-ui'

export const styles = {
  header: csx({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
  }),
  actions: csx({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: '$space-5',
  }),
  content: csx({
    display: 'flex',
    flexDirection: 'column',
    gap: '$space-1',
  }),
  legend: csx({
    marginTop: '$space-1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  }),
  iconContainer: csx({
    marginTop: '$space-2',
    display: 'inline-block',
    color: '$secondary',
  }),
  hoverable: csx({
    'button[data-open="false"]': {
      opacity: 0,
      transition: 'opacity 0.1s',
    },
    ':hover': {
      'button[data-open="false"]': {
        opacity: 1,
      },
    },
  }),
  alertContainer: csx({
    background: '$secondary',
    paddingY: '$space-4',
    paddingX: '$space-3',
    borderRadius: 4,
    border: '$neutral',
    display: 'flex',
    alignItems: 'center',
    gap: '$space-2',
    color: '$secondary',
  }),
  utilized: csx({
    marginBottom: '$space-1',
  }),
}
